import { ZIndex } from '@rover/constants/src/styles/ZIndex';

export const overlayCommonProps = {
  height: '100%',
  justifyContent: 'center',
  left: '0',
  bottom: '0',
  right: '0',
  top: '0',
  zIndex: ZIndex.MODAL_OVERLAY.toString(),
  sx: {
    backgroundColor: 'neutral.900',
    py: '4x',
    px: ['2x', '4x'],
  },
};
export type OverlayProps = {
  children: React.ReactNode;
  collapseMobilePx?: boolean;
  onClose: () => void;
  ariaLabel: string;
};
